import qs from 'qs';
import { axiosAPI } from '@/axios';

const loadTaxonomies = (filter) => {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  if (query) {
    return axiosAPI.get(`/taxonomies${query}`);
  }
  return axiosAPI.get('/taxonomies');
};

const loadTaxonomyByKey = (taxonomyKey, filter) => {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  if (query) {
    return axiosAPI.get(`/taxonomies/${taxonomyKey}/terms${query}`);
  }
  return axiosAPI.get(`/taxonomies/${taxonomyKey}/terms`);
};

const loadTaxonomyDetail = (taxonomyKey) => {
  return axiosAPI.get(`/taxonomies/${taxonomyKey}`);
};

const loadTagDetail = (taxonomyKey, termsKey) => {
  return axiosAPI.get(`/taxonomies/${taxonomyKey}/terms/${termsKey}`);
};

const createTaxonomy = (taxonomy) => {
  return axiosAPI.post('/taxonomies', taxonomy);
};

const editTaxonomy = (taxonomyKey, taxonomy) => {
  return axiosAPI.put(`/taxonomies/${taxonomyKey}`, taxonomy);
};

const editTag = (taxonomyKey, termsKey, tag) => {
  return axiosAPI.put(`/taxonomies/${taxonomyKey}/terms/${termsKey}`, tag);
};

const createTag = (taxonomyKey, tag) => {
  return axiosAPI.post(`/taxonomies/${taxonomyKey}/terms`, tag);
};

export {
  loadTaxonomies,
  loadTaxonomyByKey,
  createTaxonomy,
  createTag,
  loadTaxonomyDetail,
  editTaxonomy,
  editTag,
  loadTagDetail,
};
